import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FemaleCondomService } from '@services/female-condom.service';
import { NavigationService } from '@services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class FemaleCondomGuard implements CanActivate {
  private readonly femaleCondomService = inject(FemaleCondomService);
  private readonly router = inject(Router);
  private readonly navigationService = inject(NavigationService);

  /**
   * Checks if the user can access the female condom page.
   *
   * @param {ActivatedRouteSnapshot} _route the activated route snapshot (unused)
   * @param {RouterStateSnapshot} state the router state snapshot
   *
   * @returns {boolean | UrlTree} true to allow navigation, or a UrlTree to redirect to the next page
   */
  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.femaleCondomService.shouldRedirectToFemaleCondom()) {
      return this.router.createUrlTree([this.navigationService.getNextNavigationUrl(state.url)]);
    }

    return true;
  }
}
